<div *ngIf="data">
  <div class="row" style="border-bottom: 2px solid #ccc; margin-bottom: 7px">
    <div class="col-sm-11 movable">
      <h3
        class="head"
        cdkDrag
        cdkDragHandle
        cdkDragRootElement=".cdk-overlay-pane"
      >
        {{ data.mode | uppercase }} GROUP
      </h3>
    </div>

    <div class="col-sm-1">
      <button
        type="button"
        class="btn btn-dark btn-circle btn-xl"
        [mat-dialog-close]="true"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span aria-hidden="true">×</span>
      </button>
    </div>
  </div>
  <form [formGroup]="addOrEditform">
    <div class="successMessage alert-dismissible">
      <div *ngIf="warningMessage" class="alert alert-warning" role="alert">
        {{ warningMessage }}
        <button
          type="button"
          class="btn-close"
          (click)="removeMessage()"
          data-bs-dismiss="alert"
          aria-label="Close"
        ></button>
      </div>
  
      <div *ngIf="successMessage" class="alert alert-success" role="alert">
      {{ successMessage }}
      <button
        type="button"
        class="btn-close"
        (click)="removeMessage()"
        data-bs-dismiss="alert"
        aria-label="Close"
      ></button>
      </div>
    </div>
    <div class="row" style="margin-top: 10px">
      <!-- <div class="col-md-6">
        <div class="drpchildctrl">
          <span class="v1"></span>
          <label required class="searchLable">DOCK </label>

          <p-dropdown
            id="selSupplier"
            [filter]="true"
            [options]="data.dock"
            [virtualScroll]="true" 
            [itemSize]="25"
            [showTransitionOptions]="'0ms'" 
            placeholder="Select" 
            formControlName="dock"
            optionLabel="dock" 
            optionValue="dock"
            [resetFilterOnHide]="true"
            [hideTransitionOptions]="'0ms'" 
            autoWidth="true" 
            [style]="{ width: '100%' }"
            scrollHeight="180px">
          >
          </p-dropdown>
          <ng-container *ngIf="addOrEdit.dock.errors && submitted">
            <small *ngIf="addOrEdit.dock.errors?.required">
              Dock is required.
            </small>
          </ng-container>
        </div>
      </div> -->
      <!-- <div class="col-md-6">
        <div class="drpchildctrl">
        </div>
      </div> -->
      <div class="col-md-6">
        <div class="drpchildctrl">
          <span class="v1"></span>
          <label required class="searchLable">GROUP NAME</label>
          <input
          formControlName="groupName"
          class="key"
          type="text"
          placeholder="--Type--"
          maxlength="20"
          />
          <ng-container *ngIf="addOrEdit.groupName.errors && submitted">
            <small *ngIf="addOrEdit.groupName.errors?.required">
              Group Name is required.
            </small>
          </ng-container>
        </div>
        <!-- readonly -->
      </div>
      <div class="row" style="margin-top: 10px">
      <div class="col-md-6">
        <div class="drpchildctrl">
          <span class="v1"></span>
          <label class="searchLable">COUNT CYCLE</label>
          <input
          formControlName="countCycle"
          class="key"
          type="text"
          placeholder="--Type--"
          (input)="onInput($event)"
          maxlength="3"
          />
          <ng-container *ngIf="addOrEdit.countCycle.errors && submitted">
            <small *ngIf="addOrEdit.countCycle.errors?.required">
              Count Cycle is required.
            </small>
          </ng-container>
        </div>
      </div>
          </div>
        </div>

    <ng-container *ngIf="errorMessage1">
      <p style="color: red ;">{{ errorMessage1 }}</p>
    </ng-container>
  </form>
 
  
  <div class="text-right" style="margin-top: 30px">
    <button class="review_btn" mat-button (click)="callRespectiveFunction()">
      Save
    </button>

    <button class="cancel_btn" mat-button mat-dialog-close="cancel">
      Cancel
    </button>
  </div>
</div>
